import React, { useState } from 'react'
import axios from 'axios'
import Alert from 'react-s-alert'
import TextField from '@material-ui/core/TextField';
import AuthGroupWrapper from '../Auth/AuthGroupWrapper'

// Same this as the equipment, just with the loan products...

const LoanProducts = (props) => {

  const [viewDetails, setViewDetails] = useState('')
  const [edit, setEdit] = useState('')

  const { loanId, loanInterest, loanName, loanTerm, prePayment, postPayment, interestOnlyPayment, itc, specialPrice, isPpa, ppaEscalator, ppaRate, dealerFee } = props.loan

  const [name, setName] = useState(loanName)
  const [term, setTerm] = useState(loanTerm)
  const [interest, setInterest] = useState(loanInterest)
  const [newDealerFee, setNewDealerFee] = useState(dealerFee)
  const [prePmtFactor, setPrePmtFactor] = useState(prePayment)
  const [noItcPmtFactor, setNoItcPmtFactor] = useState(postPayment)
  const [intOnlyPmtFactor, setIntOnlyPmtFactor] = useState(interestOnlyPayment)
  const [newItc, setNewItc] = useState(itc)
  const [ppa, setPpa] = useState(isPpa)
  const [escalator, setEscalator] = useState(ppaEscalator)
  const [rate, setRate] = useState(ppaEscalator)
  const [newSpecialPrice, setNewSpecialPrice] = useState(specialPrice)

  // console.log(props.loan)

  const updateLoanProduct = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_loan_product', loan_id: loanId, loan_name: name, loan_term: term, loan_interest: interest, pre_pmt_factor: prePmtFactor, no_itc_pmt_factor: noItcPmtFactor, int_only_pmt_factor: intOnlyPmtFactor, itc: newItc, special_price: newSpecialPrice, active: 1, ppa: ppa, ppa_rate: rate, ppa_escalator: escalator, dealer_fee: newDealerFee })
      .then((res) => {
        props.getLoanProducts()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${loanName} ${loanTerm} yr ${loanInterest}% has been updated.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const deleteLoanProduct = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_loan_product', loan_id: loanId, loan_name: name, loan_term: term, loan_interest: interest, pre_pmt_factor: prePmtFactor, no_itc_pmt_factor: noItcPmtFactor, int_only_pmt_factor: intOnlyPmtFactor, itc: newItc, special_price: newSpecialPrice, active: 0, ppa: ppa, ppa_rate: rate, ppa_escalator: escalator, dealer_fee: newDealerFee })
      .then((res) => {
        props.getLoanProducts()
        // console.log(res)
        if (res.data.success) {
          Alert.success(`${loanName} ${loanTerm} yr ${loanInterest}% has been deleted.`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 50000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
      })
  }

  const deleteConfirm = () => {
    if (window.confirm('Are you absolutely sure you want to delete this?')) {
      setEdit(!edit)
      deleteLoanProduct()
    }
  }

  // console.log(props.loan)
  return (
    <div className='items'>
      {+ppa === 1 ? (
        <>
          <h3>{loanName} ${ppaRate}  {(+ppaEscalator * 100).toFixed(2)}%</h3>
          <div>
            <span>PPA Rate: ${ppaRate}</span>
          </div>
          <div>
            <span>PPA Escalator: {(+ppaEscalator * 100).toFixed(2)}%</span>
          </div>
        </>
      ) : (
        <>
          <h3>{loanName} {loanTerm} year {loanInterest}%</h3>
          <div>
            <span>With ITC Payment Factor: {prePayment}</span>
          </div>
          <div>
            <span>With Out ITC Payment Factor: {postPayment}</span>
          </div>
          <div>
            <span>Interest Only Payment Factor: {interestOnlyPayment > 0 ? (interestOnlyPayment) : ('N/A')}</span>
          </div>
          <div>
            <span>ITC: {itc * 100}%</span>
          </div>
          <div>
            <span>Special Override Pricing: {specialPrice > 0 ? `$${specialPrice}/watt` : 'N/A'}</span>
          </div>
          <div>
            <span>Dealer Fee: {newDealerFee}</span>
          </div>
        </>
      )}

      {edit ? (
        <>
          <form >
            <span>Is a PPA Product? </span>
            <input className='input' type="radio" name='ppa' onChange={e => setPpa('1')} checked={ppa === '1' ? 'checked' : ''} />
            <span>Yes</span>
            <input className='input' type="radio" name='ppa' onChange={e => setPpa('0')} checked={ppa === '0' ? 'checked' : ''} />
            <span>No</span>
          </form>
          {+ppa === 1 ? (
            <>
              <div className='addItem'>
                <div className='addItem1'>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Financial Partner' onChange={e => setName(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Term Length' onChange={e => setTerm(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='PPA Rate' onChange={e => setRate(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='PPA Escalator' onChange={e => setEscalator(e.target.value)}></TextField>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className='addItem'>
                <div className='addItem1'>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Financial Partner' onChange={e => setName(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Term Length' onChange={e => setTerm(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Interest Rate' onChange={e => setInterest(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='pmt ITC Applied' onChange={e => setPrePmtFactor(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Dealer Fee' onChange={e => setNewDealerFee(e.target.value)}></TextField>
                </div>
                <div className='addItem1'>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='pmt ITC NOT Applied' onChange={e => setNoItcPmtFactor(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='interest only' onChange={e => setIntOnlyPmtFactor(e.target.value)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='ITC' onChange={e => setNewItc(e.target.value / 100)}></TextField>
                  <TextField className='input' style={{ width: 225 }} variant="filled" size="small" margin="dense" label='Optional Special PPW' helperText={`Increase PPW to this price when loan is selected`} onChange={e => setNewSpecialPrice(e.target.value)}></TextField>
                </div>
              </div>
            </>
          )}
          <div className='editButtons'>
            <div className='editButtonColumn'>
              <button onClick={() => { setEdit(!edit); updateLoanProduct() }} >Confirm Edit of {loanName} {loanTerm} {loanInterest}%</button>
            </div>
            <div className='editButtonColumn'>
              <button onClick={() => setEdit(!edit)} >Cancel</button>
            </div>
            <div className='editButtonColumn'>
              <button onClick={() => deleteConfirm()} >Delete</button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div>
            <AuthGroupWrapper requiredGroups={['Super-Admin']}>
              <button onClick={() => setEdit(!edit)} >Edit {loanName} {loanTerm} {loanInterest}%</button>
            </AuthGroupWrapper>
          </div>
        </>
      )}

    </div>
  )
}
export default LoanProducts
